/** Um passo do "como funciona". O número é conteúdo — é ele que diz a ordem —,
 *  e por isso está no texto, e não num `::before` que o leitor de tela pula. */
function StepCard({ numero, titulo, texto }) {
  return (
    <div className="step-card">
      <span className="step-number">{numero}</span>
      <h3 className="step-title">{titulo}</h3>
      <p className="step-text">{texto}</p>
    </div>
  );
}

export default StepCard;
